import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class PickingReportService {z
  /**
   * Creates an instance of picking report service.
   * @param http HttpClient
   */
  constructor(private http: HttpClient, public apiService: ApiService) {}
  /**
   * Gets container report
   * @param params any
   * @returns Observable<any[]>
   */
  getContainerReport(params: any ): Observable<any> {
    return this.http.get(`${environment.apiRunPickingReport}/orders/container/report`, {
      params,
    });
  }

    /**
   * Gets report picking
   * @param [params] any
   * @returns Observable<any[]>
   */
  getReportPicking(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/reports/ordersPicking`,
      params
    );
  }
  /**
   * Gets report picking pending
   * @param [params] any
   * @returns Observable<any[]>
   */
  getReportPickingPending(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/reports/ordersPicking/pending`,
      params
    );
  }
  /**
   * Gets report picking missing
   * @param [params] any
   * @returns Observable<any[]>
   */
  getReportPickingMissing(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/reports/ordersPicking/missing`,
      params
    );
  }
  /**
   * Gets report picking to withdraw
   * @param [params] any
   * @returns Observable<any[]>
   */
  getReportPickingToWithdraw(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/reports/ordersPicking/toWithdraw`,
      params
    );
  }
  /**
   * Gets report picking print pending
   * @param [params] any
   * @returns Observable<any[]>
   */
  getReportPickingPrintPending(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/reports/ordersPicking/printPending`,
      params
    );
  }

  /**
   * Gets report orders pending xls
   * @param params
   * @returns ReportOrdersTotal[]
   */
  getReportOrdersPendingXls(params: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/orders/xls/pending`,
      params
    );
  }

    /**
   * Gets orders report
   * @param params any
   * @returns  Observable<any>
   */
  getOrdersReport(params: any): Observable<any> {
    return this.apiService.post(`${this.apiService.pickingReport}/orders/pickingReport`, params);
  }

  geOrdersLeaveOrder(params?: any) {
    return this.apiService.get(
      `${this.apiService.pickingReport}/orders/leaveOrder`,
      params
    );
  }
}
